import { defineMessages } from 'react-intl'

export const PROFILE_INTEREST_FOCUS = {
  WORKOUTS: 'WORKOUTS',
  NUTRITION: 'NUTRITION',
  BOTH: 'BOTH'
}

export const PROFILE_INTEREST_FOCUSES = Object.values(PROFILE_INTEREST_FOCUS)

const labels = defineMessages({
  workouts: {
    id: 'ProfileInterestFocus.workouts',
    defaultMessage: 'Workouts'
  },
  nutrition: {
    id: 'ProfileInterestFocus.nutrition',
    defaultMessage: 'Nutrition'
  },
  both: {
    id: 'ProfileInterestFocus.both',
    defaultMessage: 'Workouts & Nutrition'
  }
})

export const PROFILE_INTEREST_FOCUS_MESSAGE = {
  [PROFILE_INTEREST_FOCUS.WORKOUTS]: labels.workouts,
  [PROFILE_INTEREST_FOCUS.NUTRITION]: labels.nutrition,
  [PROFILE_INTEREST_FOCUS.BOTH]: labels.both
}

export const PROFILE_INTEREST_FOCUS_EMOJI = {
  [PROFILE_INTEREST_FOCUS.WORKOUTS]: '🏋️',
  [PROFILE_INTEREST_FOCUS.NUTRITION]: '🍛',
  [PROFILE_INTEREST_FOCUS.BOTH]: '⚡️'
}
